/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import AccountLayout from 'components/RichProfile/MyAccount/AccountLayout/AccountLayout';
import AutoReplenishmentPageContent from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentPageContent';

class AutoReplenishmentMain extends BaseClass {
    componentDidMount() {
        const { loadContentfulContent = () => {} } = this.props;

        if (Sephora.configurationSettings.isAutoReplenishEmptyHubEnabled) {
            loadContentfulContent();
        }
    }

    render() {
        const { localization = {} } = this.props;

        return (
            <AccountLayout
                section='account'
                page='autoReplenishment'
                title={localization.autoReplenish}
            >
                <AutoReplenishmentPageContent />
            </AccountLayout>
        );
    }
}

AutoReplenishmentMain.propTypes = {
    loadContentfulContent: PropTypes.func,
    localization: PropTypes.object
};

export default wrapComponent(AutoReplenishmentMain, 'AutoReplenishmentMain', true);
